<template>
  <DocumentContent :content="page.data" v-if="page?.type === 'document'" />
  <div class="main-page sliceZone" v-else-if="page?.type === 'landing'">
    <SliceZone :slices="page?.data?.slices || []" :components="components" />
  </div>
</template>

<script setup lang="ts">
import { components } from "~/slices";
const prismic = usePrismic();
const { $head } = useNuxtApp();
const route = useRoute();
const uid = route.params.uid;

defineOptions({
  name: "inner-Page",
});

const {
  data: {
    value: { landing, document },
  },
  error: fetchError,
} = await useAsyncData(uid, async () => {
  const [document, landing] = await Promise.all([
    await prismic.client.getByUID("document", uid).catch((e) => null),
    await prismic.client.getByUID("landing", uid).catch((e) => null),
  ]);
  return { landing, document };
});

const page = landing || document;
if (fetchError.value || !page) {
  throw createError({
    statusCode: 404,
    message: "Page not found",
    fatal: true,
  });
}

const pageType = document ? "document" : "landing";

useHead(
  $head(
    {
      meta_title: page?.data?.meta_title,
      meta_keywords: page?.data?.meta_keywords,
      meta_description: page?.data?.meta_description,
      meta_image: page?.data?.meta_image,
      alternate_languages: page?.alternate_languages,
      lastmodified: page?.last_publication_date || page?.first_publication_date,
    },
    {
      bodyAttrs: {
        class: pageType + "-page",
      },
    }
  )
);
</script>
<style lang="scss" scoped></style>
